/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux';
import {
  firebaseConnect,
  // getFirebase,
  // isLoaded,
  // isEmpty
} from 'react-redux-firebase'
import { withRouter } from 'react-router-dom'
import { pathOr as RpathOr } from 'ramda';
import { command as commandActions } from '../../redux/actions'
import { contextA } from '../../redux/store/configureStore';

class Receptor extends Component {
  componentDidUpdate() {
    const commandKeys = this.props.commands && Object.keys(this.props.commands)
    const command = (
      commandKeys && commandKeys[0] ? this.props.commands[commandKeys[0]].command : null
    )
    // console.log('COMMAND', command);
    this.props.onCommand(command)
  }

  render() {
    // const path = RpathOr('/', ['location', 'pathname'], this.props);
    // const commands = this.props.commands && Object.keys(this.props.commands)
    //   .reduce((acc, current, currentIndex, arr) => {
    //     return acc + this.props.commands[current].command
    //   }, '')

    // console.log('commands', commands);

    return (null
    // <div>Receptor {commands}</div>
    )
  }
}

const mapStateToProps = (state/* , ownProps */) => {
  // const uid = state.firebase.auth.uid;
  const uid = RpathOr(null, ['firebase', 'auth', 'uid'], state);
  // console.log('mapStateToPropsReceptor', uid, state, ownProps);
  return ({
    context: state.context,
    presence: state.firebase.data && state.firebase.data.presence,
    profile: state.firebase.profile,
    // isLogged: state.auth.isLogged,
    auth: state.firebase.auth,
    settings: state.settings,
    departments: state.firebase.data && state.firebase.data.departments,
    commands: (
      // state.firebase.data.remote && state.firebase.data.remote[state.firebase.auth.uid].messages
      state.firebase.data.remote && state.firebase.data.remote[uid] && state.firebase.data.remote[uid].messages
    ),
  })
};

const mapDispatchToProps = dispatch => bindActionCreators(commandActions, dispatch)

const firebaseConfigReceptor = (props) => {
  const { firebase } = props;
  return (
    [
      { path: `/remote/${firebase._.authUid}/messages`, queryParams: ['limitToLast=1'] },
    ]
  )
}
const ComposedComponent = compose(
  firebaseConnect(firebaseConfigReceptor),
  connect(mapStateToProps, mapDispatchToProps, null, {
    context: contextA,
  }),
)(Receptor)


const RoutedComponent = withRouter(ComposedComponent)

export default RoutedComponent



// WEBPACK FOOTER //
// ./src/components/receptor/Receptor.js